import gql from 'graphql-tag'

export const TOTAL_GROUP_SYSTEM_USER_REPORT = gql`
    query($id: ID!) {
        totalGroupSystemUsersReport(id: $id)
    }
`
